import SocialLinks from "./SocialLinks";

function Footer() {
    return (
        <div className="footer">
            <SocialLinks />
        </div>
    )
}

export default Footer;
